/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { clickTracker } from '../../lib/common';
import { handleImpressionsTrack } from '../../api';
import { useAuth } from '../../contexts/auth';

export default function PaymentBounce({ redirectUrl, projectId, faqObj }) {
  const [authState] = useAuth();
  return (
    <>
      {projectId === 'genio' ? (
        <div
          className="font12 fw400 color777"
          id="payments-faqs-ans"
          dangerouslySetInnerHTML={{ __html: faqObj?.ans }}
        />
      ) : (
        <div className="font12 fw400 color777">
          <a
            style={{ textDecoration: 'underline', color: 'blue' }}
            href={redirectUrl && `${redirectUrl.manageCampaign}&reactivate=1`}
            onClick={async () => {
              await clickTracker(`FAQ_paybounced_link`, `ecs_FAQ_paybounced`);
              await clickTracker(`FAQ_paybounce_redirection`, `ecs_FAQ_paybounce`);
              if (projectId === 'csportal') {
                const liVal = 'click';
                const liTrd = `cta_clickhere`;
                const faqTypeVal = '';
                const othersData = [];
                const llTrd = `issue_ecs`;
                const llTrdInside = `faq_${faqObj?.faqKey}`;
                await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
              }
            }}
          >
            Click Here
          </a>{' '}
          to pay your bounced ECS amount
        </div>
      )}
    </>
  );
}

PaymentBounce.propTypes = {
  redirectUrl: PropTypes.object,
  projectId: PropTypes.string,
  faqObj: PropTypes.object,
};
